import DefaultZodiacLayer from "../../components/editor/layers/zodiac/DefaultZodiacLayer";
import ColorfulZodiacLayer from "../../components/editor/layers/zodiac/ColorfulZodiacLayer";

export const zodiacStyles = [
    {
        'name': 'Klassiek',
        'slug': 'default',
        'preview': '/img/editor/coordinates/bigcoordinates.png',
        'layers': {
            DefaultZodiacLayer
        },
    },
    {
        'name': 'Kleurrijk',
        'slug': 'colorful',
        'preview': '/img/editor/coordinates/bigcoordinates.png',
        'layers': {
            ColorfulZodiacLayer
        },
    },
];